/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {AccountLink} from '@ion/core/src/types/entities';
import {isArrayDeepEmpty} from '@ion/core/src/utils/ArrayUtil';

/**
 * Determines whether the tracking groups filter should render.
 *
 * ```typescript
 * import {shouldRenderGroupsFilter} from '@/components/filter/TrackingFilterUtils';
 *
 * ...
 *
 * const shouldRender = shouldRenderGroupsFilter(true, accountHierarchy, false);
 * ```
 *
 * @param isPhone          Indicates whether the application uses the mobile view.
 * @param accountHierarchy Account hierarchy for the selected global group.
 * @param isDisplayed      Indicates whether the filter is currently displayed.
 * @returns                `true` when the groups filter should render, otherwise
 *                         `false`.
 */
export const shouldRenderGroupsFilter = (
  isPhone: boolean,
  accountHierarchy: AccountLink[],
  isDisplayed: boolean
): boolean => (
  isDisplayed || (isPhone && !isArrayDeepEmpty(accountHierarchy))
);
